// extracted by mini-css-extract-plugin
export default {"fixIcon":"index_fixIcon_t7axP","fixTopIcon":"index_fixTopIcon_Vlm0D","fixBottomIcon":"index_fixBottomIcon_6D-KO"};